(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  function initMobileSlickSlider() {
    var $slider = $('.nws-related-products .nws-blocklayout');

    if (!$slider.length) return;

    function setupSlick() {
      if (window.innerWidth < 750) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 2, // ✅ Always show 2 slides
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            centerPadding: '20px',
            autoplay: false,
            centerMode: false,
            speed: 500,
            cssEase: 'ease',
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    }

    setupSlick();
    $(window).on('resize', setupSlick);
  }

  var loadProductRecommendationsIntoSection = function () {
    var productRecommendationsSection = document.querySelector('.related-products');
    if (productRecommendationsSection === null) return;

    var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
    var prod_thumb_img_ratio = productRecommendationsSection.dataset.prod_thumb_img_ratio;
    var requestUrl = productRecommendationsSection.dataset.url;

    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector('.related-products').innerHTML;

        // init masonry layout
        $(document).trigger('loadmasonry');

        // ✅ Initialize Slick after products are loaded
        initMobileSlickSlider();
      }
    };
    request.send();
  };

  // Handle section reload in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'related-products') {
      loadProductRecommendationsIntoSection();
    }
  });

  // Unload cleanup
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.detail.sectionId === 'related-products') {
      $('.nws-blocklayout', event.target).masonry('destroy');
    }
  });

  // Initial load
  document.addEventListener('DOMContentLoaded', function () {
    loadProductRecommendationsIntoSection();
  });

  } catch(e) { console.error(e); }
})();
})();
